module.exports = __webpack_public_path__ + "img/1039726-31-2.73c8ca65.png";